import React, {useEffect, useState} from "react";
import { Menu, Badge } from "antd";
import { Link, useRouteMatch } from "react-router-dom";
import {
  EnvironmentOutlined,
  LineChartOutlined,
  RadarChartOutlined,
  SettingOutlined,
  DashboardOutlined
} from "@ant-design/icons";
//traemos el context
import { useAuth } from "../../authentication";
import { useAppContext } from "../../context/AppContext";
//-----------------
import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import SubMenu from "antd/lib/menu/SubMenu";
import MenuItem from "antd/lib/menu/MenuItem";

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);
  const [trackingEnabled, setTrackingEnabled] = useState(true);
  const [proximityEnabled, setProximityEnabled] = useState(false);
  const { totalAlerts } = useAppContext();

  useEffect(() => {
    const tracking = localStorage.getItem("tracking_enabled");
    const proximity = localStorage.getItem("proximity_enabled");
    if (tracking === "true") {
      setTrackingEnabled(true);
    } else {
      setTrackingEnabled(false);
    }
    if (proximity === "true") {
      setProximityEnabled(true);
    } else {
      setProximityEnabled(false);
    }
  }, []);

  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  //traemos los datos del usuario logueado
  const { authUser } = useAuth();
  //-----------
  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];

  const getNavStyleSubMenuClass = (navStyle) => {
    if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      return "gx-no-header-submenu-popup";
    }
    return "";
  };

  const goToAdminPage = () => {
    window.open("https://iotstracontech.stracontech.com/", "_self");
  };

  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <div className="gx-sidebar-content">
        <div
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        >
          <UserProfile />
          {/* <AppsNavigation /> */}
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
            mode="inline"
          >
            {authUser.is_active ? (
              <>
                <Menu.Item key="tracking" style={{ display: 'flex', alignItems: 'center' }}>
                  <Link to="/tracking" style={{ display: 'flex', alignItems: 'center' }}>
                    <EnvironmentOutlined style={{ fontSize: '16px' }} />
                    <span style={{ marginLeft: '10px' }}>Tracking</span>
                    {totalAlerts > 0 && (
                      <Badge 
                        count={totalAlerts} 
                        style={{ 
                          marginLeft: 'auto',
                          backgroundColor: '#ff4d4f' 
                        }} 
                      />
                    )}
                  </Link>
                </Menu.Item>

                <Menu.Item key="paths">
                  <Link to="/paths" style={{ display: 'flex', alignItems: 'center' }}>
                    <LineChartOutlined style={{ fontSize: '16px' }} />
                    <span style={{ marginLeft: '10px' }}>Paths</span>
                  </Link>
                </Menu.Item>

                {proximityEnabled && <Menu.Item key={'proximity'}>
                  <Link to="/proximity" style={{ display: 'flex', alignItems: 'center' }}>
                    <RadarChartOutlined style={{ fontSize: '16px' }} />
                    <span style={{ marginLeft: '10px' }}>Proximidad</span>
                  </Link>
                </Menu.Item>}

                <Menu.Item onClick={() => goToAdminPage()}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <SettingOutlined style={{ fontSize: '16px' }} />
                    <span style={{ marginLeft: '10px' }}>Admin</span>
                  </div>
                </Menu.Item>

                {/* <SubMenu
                  key="Ajustes"
                  popupClassName={getNavStyleSubMenuClass(navStyle)}
                  title={
                    <span>
                      {" "}
                      <i className="icon icon-widgets" />
                      <span>
                        <IntlMessages id="sidebar.dashboard" />
                        Configuración
                      </span>
                    </span>
                  }
                >
                  <Menu.Item key="setting">
                    <Link to="/settings">
                      <i className="icon icon-widgets" />
                      <span>Ajustes</span>
                    </Link>
                  </Menu.Item>
                  <Menu.Item key="usuarios">
                  <Link to="/usuarios">
                    <i className="icon icon-widgets" />
                    <span>Usuarios</span>
                  </Link>
                </Menu.Item>
                </SubMenu> */}
              </>
            ) : (
              <>
                <Menu.Item key="sample">
                  <Link to="/sample">
                    <i className="icon icon-widgets" />
                    <span>
                      <IntlMessages id="sidebar.samplePage" />
                    </span>
                  </Link>
                </Menu.Item>
              </>
            )}
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);
